// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Learning-pyate-app-l{
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
    width: 100%;
    max-width: 1400px;
    margin-top: 20px;
    overflow: hidden;
    background-color:#F4F2EE;
}
.learn-nav-p{
    display: flex;
    flex-direction: row;
    background-color:white;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 20px;
    text-decoration: none;
}



.logo-learn{
    color: white;
    font-size: 16pt;
    font-weight: bold;
}
.logo-container-learn{
    margin-right: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    gap: 20px;
}

.nav-links-learn{
    display: flex;
    flex-direction: row;
    list-style: none;
    display: flex;
    gap: 20px;
    text-decoration: none;
    font-size: 15pt;
    font-weight: 500;
    margin-top: 4px;
    text-transform: uppercase;
}

.nav-links-learn a {
    color: gray;
    text-decoration: none;
    font-size: .875rem;
    padding: 5px;
    justify-content: center;
    padding-bottom: 3px;
    transition: color 0.3s ease;
}
.nav-item-learn {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
}
.nav-item-learn.active {
    color:white;
    background-color: #ffc107;
    justify-content: center;
    border-radius: 10px; /* Active color */
}

.image-search-div{
    margin-top: 20px;
}

.search-bar-header-learn {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: 20px;
  
}

#search-header-learn {
    padding: 8px 10px;
    border-radius: 10px;
    width: 200px;
    background-color:#f0f4f9;    ;
    border: 1px solid #ccc;
    font-size: 1rem;
    outline: none;
}

.search-button-learn {
    padding: 8px 10px;
    background-color: #555;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
}

.search-button-learn:hover {
    background-color: #777;
}
.content-learn-search{
    margin-top: -300px;
    margin-bottom: 100px;
    margin-left: 80px;
    color: white;
    margin-right: 20px;
    font-size: 16px;
}

.card-learn-comp{
   display: flex;
   flex-direction: column;
}
.shop_card-learn{
    width: 200px;
    margin: 25px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    overflow: hidden;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.card-image-learn{
    width: 100%;
    height: 150px;
    object-fit: fill;
    
}
.shop_js-learn{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;       
    gap: 5px;             
    justify-content: center; 
}
.shop_card-learn:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }

  .shop_container-learn {
    padding: 5px;
}

.cart-btn-entroll{
    background-color: rgb(4, 69, 144);
    color: white;
    padding: 5px 9px;
}

.Learn-filter{
    max-width: 400px;
    margin-top: -400px;
}

.filter-rec-btn-s-l{
    display: flex;
    margin:20px;
    border-bottom: 1px solid #ddd;
    gap: 20px;
}
.filter-rec-btn-s-l button{
 background-color: inherit;
 color: black;
}
.filter-rec-btn-s-l button:hover{
    background-color: inherit;
}

.filter-products-main-box-learn{
    width: 300px;
    display: flex; 
    margin-top: 20px; 
    background-color: #fff;
    border-radius:7px;
    border: 1px solid #ddd;
    overflow: hidden;
    min-width: 300px;
    margin-left: 30px;
  }
  
  @media(max-width: 540px){
    .filter-products-main-box-learn{
      flex-direction: column;
    }
  }
  
  .filter-products-main-box-learn .my-products{
    flex: 3.3 1;
    /* border: 1px solid green; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;  
  }
  
  @media(max-width: 540px){
    .filter-products-main-box-learn .my-products{
      width: 100%;
      margin-top: 30px; 
    }
  }
  
  .filter-box-learn{
    display: flex;
    flex-direction: column;
    /* border: 1px solid red; */
    flex: 0.7 1;
    padding-left: 15px;
    padding-top: 10px;
  }
  
  @media(max-width: 540px){
    .filter-box-learn{
      width: 100%;
      padding-left: 10px;
      padding-top: 5px;
    }
  }
  
  .filter-box-learn h6{
    font-weight: 600;
    margin-top: 60px;
   
  }
  
  .filter-box-learn span{
    cursor: pointer;
    margin: 15px 0px;
    font-size: 14px;
  }
  
  .filter-box-learn span.ElectronicDevices{
    color: #e00a02;
  }
  
  .filter-box-learn span.MobileAccessories{
    color: #e00a02;
  }
  
  .filter-box-learn span.TVAndHomeAppliances{
    color: #e00a02;
  }
  
  .filter-box-learn span.SportsAndOutdoors{
    color: #e00a02;
  }
  
  .HealthAndBeauty,.HomeAndLifestyle,.MensFashion,.WatchesBagsAndJewellery,.Groceries{
    color: #e00a02;
  }

  .learn-comp-div-out{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    
  }

  .card-learn-section{
    background-color: #fff;
    border-radius:7px;
    border: 1px solid #ddd;
    overflow: hidden;
    margin-top: 20px;
    min-width: 300px;
    margin-bottom: 10px;
    margin-left: 20px;
    margin-right: 10px;
  }


  @media (max-width: 768px) {
   .Learning-pyate-app-l{
    margin-top:100px;
    gap: 5px;
   }
   .learn-nav-p{
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
   }
    .filter-products-main-box-learn {
        display: none;
    }
    .card-learn-section{
      width: 100%;
    }
  #search-header-learn{
    width: 200px;
  }
  }
  
  
  @media (max-width: 480px) {
    .shop-card {
        width: 100%; 
        margin: 10px 0; 
    }
  
    .card-image {
        height: auto;
    }
  
    .add-card-button {
        margin-left: 0;
        margin-right: 0;
        width: auto;
    }
  
    .cart-btn {
        font-size: 12px; 
    }
  
    .filter-rec-btn-s{
      flex-wrap: wrap;
      gap: 5px;
    }
  
    .map-shop{
      width: 100%;
    }
  
    .map-container{
      width: 100%;
      height: 850px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Learning.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,qBAAqB;AACzB;;;;AAIA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB,EAAE,iBAAiB;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,uBAAuB;AAC3B;AACA;IACI,wCAAwC;EAC1C;;EAEA;IACE,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,SAAS;AACb;AACA;CACC,yBAAyB;CACzB,YAAY;AACb;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,WAAS;IACT,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE;MACE,WAAW;MACX,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,WAAS;IACT,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE;MACE,WAAW;MACX,kBAAkB;MAClB,gBAAgB;IAClB;EACF;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;;EAElB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;;EAE7B;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;GACC;IACC,gBAAgB;IAChB,QAAQ;GACT;GACA;IACC,aAAa;IACb,eAAe;IACf,eAAe;GAChB;IACC;QACI,aAAa;IACjB;IACA;MACE,WAAW;IACb;EACF;IACE,YAAY;EACd;EACA;;;EAGA;IACE;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;MACE,eAAe;MACf,QAAQ;IACV;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;MACX,aAAa;IACf;EACF","sourcesContent":[".Learning-pyate-app-l{\n    display: flex;\n    flex-direction: column;\n    font-family: Arial, sans-serif;\n    width: 100%;\n    max-width: 1400px;\n    margin-top: 20px;\n    overflow: hidden;\n    background-color:#F4F2EE;\n}\n.learn-nav-p{\n    display: flex;\n    flex-direction: row;\n    background-color:white;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    padding: 20px;\n    text-decoration: none;\n}\n\n\n\n.logo-learn{\n    color: white;\n    font-size: 16pt;\n    font-weight: bold;\n}\n.logo-container-learn{\n    margin-right: 200px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 20px;\n}\n\n.nav-links-learn{\n    display: flex;\n    flex-direction: row;\n    list-style: none;\n    display: flex;\n    gap: 20px;\n    text-decoration: none;\n    font-size: 15pt;\n    font-weight: 500;\n    margin-top: 4px;\n    text-transform: uppercase;\n}\n\n.nav-links-learn a {\n    color: gray;\n    text-decoration: none;\n    font-size: .875rem;\n    padding: 5px;\n    justify-content: center;\n    padding-bottom: 3px;\n    transition: color 0.3s ease;\n}\n.nav-item-learn {\n    text-decoration: none;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 14px;\n}\n.nav-item-learn.active {\n    color:white;\n    background-color: #ffc107;\n    justify-content: center;\n    border-radius: 10px; /* Active color */\n}\n\n.image-search-div{\n    margin-top: 20px;\n}\n\n.search-bar-header-learn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    margin-left: 20px;\n  \n}\n\n#search-header-learn {\n    padding: 8px 10px;\n    border-radius: 10px;\n    width: 200px;\n    background-color:#f0f4f9;    ;\n    border: 1px solid #ccc;\n    font-size: 1rem;\n    outline: none;\n}\n\n.search-button-learn {\n    padding: 8px 10px;\n    background-color: #555;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1rem;\n}\n\n.search-button-learn:hover {\n    background-color: #777;\n}\n.content-learn-search{\n    margin-top: -300px;\n    margin-bottom: 100px;\n    margin-left: 80px;\n    color: white;\n    margin-right: 20px;\n    font-size: 16px;\n}\n\n.card-learn-comp{\n   display: flex;\n   flex-direction: column;\n}\n.shop_card-learn{\n    width: 200px;\n    margin: 25px;\n    border: 1px solid #ccc;\n    margin-bottom: 20px;\n    overflow: hidden;\n    text-align: center;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.card-image-learn{\n    width: 100%;\n    height: 150px;\n    object-fit: fill;\n    \n}\n.shop_js-learn{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;       \n    gap: 5px;             \n    justify-content: center; \n}\n.shop_card-learn:hover {\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n  }\n\n  .shop_container-learn {\n    padding: 5px;\n}\n\n.cart-btn-entroll{\n    background-color: rgb(4, 69, 144);\n    color: white;\n    padding: 5px 9px;\n}\n\n.Learn-filter{\n    max-width: 400px;\n    margin-top: -400px;\n}\n\n.filter-rec-btn-s-l{\n    display: flex;\n    margin:20px;\n    border-bottom: 1px solid #ddd;\n    gap: 20px;\n}\n.filter-rec-btn-s-l button{\n background-color: inherit;\n color: black;\n}\n.filter-rec-btn-s-l button:hover{\n    background-color: inherit;\n}\n\n.filter-products-main-box-learn{\n    width: 300px;\n    display: flex; \n    margin-top: 20px; \n    background-color: #fff;\n    border-radius:7px;\n    border: 1px solid #ddd;\n    overflow: hidden;\n    min-width: 300px;\n    margin-left: 30px;\n  }\n  \n  @media(max-width: 540px){\n    .filter-products-main-box-learn{\n      flex-direction: column;\n    }\n  }\n  \n  .filter-products-main-box-learn .my-products{\n    flex: 3.3;\n    /* border: 1px solid green; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;  \n  }\n  \n  @media(max-width: 540px){\n    .filter-products-main-box-learn .my-products{\n      width: 100%;\n      margin-top: 30px; \n    }\n  }\n  \n  .filter-box-learn{\n    display: flex;\n    flex-direction: column;\n    /* border: 1px solid red; */\n    flex: 0.7;\n    padding-left: 15px;\n    padding-top: 10px;\n  }\n  \n  @media(max-width: 540px){\n    .filter-box-learn{\n      width: 100%;\n      padding-left: 10px;\n      padding-top: 5px;\n    }\n  }\n  \n  .filter-box-learn h6{\n    font-weight: 600;\n    margin-top: 60px;\n   \n  }\n  \n  .filter-box-learn span{\n    cursor: pointer;\n    margin: 15px 0px;\n    font-size: 14px;\n  }\n  \n  .filter-box-learn span.ElectronicDevices{\n    color: #e00a02;\n  }\n  \n  .filter-box-learn span.MobileAccessories{\n    color: #e00a02;\n  }\n  \n  .filter-box-learn span.TVAndHomeAppliances{\n    color: #e00a02;\n  }\n  \n  .filter-box-learn span.SportsAndOutdoors{\n    color: #e00a02;\n  }\n  \n  .HealthAndBeauty,.HomeAndLifestyle,.MensFashion,.WatchesBagsAndJewellery,.Groceries{\n    color: #e00a02;\n  }\n\n  .learn-comp-div-out{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    \n  }\n\n  .card-learn-section{\n    background-color: #fff;\n    border-radius:7px;\n    border: 1px solid #ddd;\n    overflow: hidden;\n    margin-top: 20px;\n    min-width: 300px;\n    margin-bottom: 10px;\n    margin-left: 20px;\n    margin-right: 10px;\n  }\n\n\n  @media (max-width: 768px) {\n   .Learning-pyate-app-l{\n    margin-top:100px;\n    gap: 5px;\n   }\n   .learn-nav-p{\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 12px;\n   }\n    .filter-products-main-box-learn {\n        display: none;\n    }\n    .card-learn-section{\n      width: 100%;\n    }\n  #search-header-learn{\n    width: 200px;\n  }\n  }\n  \n  \n  @media (max-width: 480px) {\n    .shop-card {\n        width: 100%; \n        margin: 10px 0; \n    }\n  \n    .card-image {\n        height: auto;\n    }\n  \n    .add-card-button {\n        margin-left: 0;\n        margin-right: 0;\n        width: auto;\n    }\n  \n    .cart-btn {\n        font-size: 12px; \n    }\n  \n    .filter-rec-btn-s{\n      flex-wrap: wrap;\n      gap: 5px;\n    }\n  \n    .map-shop{\n      width: 100%;\n    }\n  \n    .map-container{\n      width: 100%;\n      height: 850px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
